import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { User as UserIcon, Calendar, Eye } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AuthorPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${API}/public/authors/${slug}`).then(r => r.ok ? r.json() : null)
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="py-20 text-center text-gray-400">Učitavam…</div>;
  if (!data) return <div className="py-20 text-center text-gray-400">Autor nije pronađen.</div>;

  const a = data.author;

  return (
    <>
      <Helmet><title>{`${a.name} — Autor na E-MINA`}</title></Helmet>
      <div className="max-w-5xl mx-auto px-4 py-8" data-testid="author-page">
        <header className="flex items-center gap-5 pb-6 border-b border-gray-200 dark:border-gray-800 mb-8">
          {a.picture ? (
            <img src={a.picture} alt={a.name} className="w-20 h-20 rounded-full object-cover" />
          ) : (
            <div className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-600"><UserIcon size={28} /></div>
          )}
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100" data-testid="author-name">{a.name}</h1>
            {a.bio && <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{a.bio}</p>}
            <p className="text-xs text-gray-400 mt-1">{data.count} objavljenih članaka</p>
          </div>
        </header>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.articles.map(art => {
            const cover = art.cover_image_url?.startsWith('http') ? art.cover_image_url : (art.cover_image_url ? `${BACKEND}${art.cover_image_url}` : null);
            return (
              <Link key={art.id} to={`/clanak/${art.slug}`} className="group" data-testid={`author-article-${art.id}`}>
                {cover && (
                  <div className="aspect-[16/10] rounded-lg overflow-hidden bg-gray-100 dark:bg-[#111827] mb-2">
                    <img src={cover} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                  </div>
                )}
                <h3 className="text-sm font-bold text-gray-900 dark:text-gray-100 line-clamp-2 group-hover:text-red-600">{art.title_hr}</h3>
                {art.excerpt_hr && <p className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2 mt-1">{art.excerpt_hr}</p>}
                <div className="flex items-center gap-3 mt-2 text-[10px] text-gray-400">
                  {art.publish_at && <span className="flex items-center gap-1"><Calendar size={10} />{new Date(art.publish_at).toLocaleDateString('hr-HR')}</span>}
                  <span className="flex items-center gap-1"><Eye size={10} />{art.views}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
}
